import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const TooltipEllipsisColumnFormatter = (cellContent, row, rowIndex, { fieldName, maxLength = 30 }) => {
  if (!cellContent) return "";
  
  const content = cellContent.toString();
  const truncated = content.length > maxLength ? content.substring(0, maxLength) + "..." : content;
  
  if (content.length <= maxLength) {
    return <span>{content}</span>;
  }
  
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`tooltip-${fieldName}-${rowIndex}`}>
          {content}
        </Tooltip>
      }
    >
      <span style={{ cursor: "pointer" }}>{truncated}</span>
    </OverlayTrigger>
  );
};

export const createTooltipEllipsisFormatter = (fieldName, maxLength = 30) => {
  return (cellContent, row, rowIndex) => 
    TooltipEllipsisColumnFormatter(cellContent, row, rowIndex, { fieldName, maxLength });
};
